import React from 'react';
import '../styles/MissionVision.css';

import missionImg from '../Assets/Images/mission.png';
import visionImg from '../Assets/Images/vision.png';
import valueImg from '../Assets/Images/photo-placeholder.png';

function MissionVision() {
  return (
    <section className="mission-vision-section">
      <div className="mv-container">
        <h2 className="mv-title">Vision & Mission</h2>

        <div className="mv-cards">

          <div className="mv-card vision">
            <img src={visionImg} alt="Our Vision" className="mv-image" />
            <h3>Our Vision</h3>
            <p>
                প্রযুক্তিগত কারিগরি শিক্ষা দিয়ে দক্ষ ও স্বনির্ভর জনশক্তি সৃষ্টি।
            </p>
          </div>

          <div className="mv-card mission">
            <img src={missionImg} alt="Our Mission" className="mv-image" />
            <h3>Our Mission</h3>
            <p>
                দক্ষ ও অভিজ্ঞ শিক্ষক দ্বারা সমাজের সুবিধা বঞ্চিত মেধাবী শিক্ষার্থীদের সম্পূর্ণ বিনামূল্যে
                প্রশিক্ষিত করে আত্ম-কর্মসংস্থানে সহায়তা সহ প্রশিক্ষিত জনবল রপ্তানির মাধ্যমে দেশের
                আর্থ সামাজিক-অবস্থার উন্নয়নে অবদান রাখা।
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
